import { render } from "./TwoAxleTractorTwoAxleSemitrailer.vue?vue&type=template&id=0b4a03f2&scoped=true&ts=true"
import script from "./TwoAxleTractorTwoAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./TwoAxleTractorTwoAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./TwoAxleTractorTwoAxleSemitrailer.vue?vue&type=style&index=0&id=0b4a03f2&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4a03f2"]])

export default __exports__